module.exports = __webpack_public_path__ + "static/media/logo_testtoken.e3defefa.png";